// src/contexts/StockVisualizationContext.js
import React, { createContext } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

// Cache results so page doesn't reload everytime 
import { useState } from 'react';


export const StockVisualizationContext = createContext();

export function StockVisualizationProvider({ children }) {
  const [selectedStock, setSelectedStock] = useLocalStorage('selectedStock', 'NVDA');
  const [selectedPeriod, setSelectedPeriod] = useLocalStorage('visualizationSelectedPeriod', '1M');

  const [chartData, setChartData] = useState([]);
  const [isChartDataLoaded, setIsChartDataLoaded] = useState(false);

  // Helper methods for stock selection
  const handleStockChange = (e) => {
    setSelectedStock(e.target.value);
  };

  const handleWatchlistStockChange = (e) => {
    if (e.target.value) {
      setSelectedStock(e.target.value);
    }
  };

  // Helper method for period selection
  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
  };

  // Reset to defaults
  // const resetToDefaults = () => {
  //   setSelectedStock('NVDA');
  //   setSelectedPeriod('1M');
  // };

  return (
    <StockVisualizationContext.Provider value={{
      // State
      selectedStock,
      selectedPeriod,
      
      // Direct setters
      setSelectedStock,
      setSelectedPeriod,
      
      // Helper methods
      handleStockChange,
      handleWatchlistStockChange,
      handlePeriodChange,
      // resetToDefaults,

      chartData,
      setChartData,
     isChartDataLoaded,
      setIsChartDataLoaded

    }}>
      {children}
    </StockVisualizationContext.Provider>
  );
}